import { ArticleWithRelations } from '@/models/request';
import { RequestArticleContextData } from '@/routes/Requests/contexts/interfaces';

export const computeControlQualityContext = ({
  view,
  article,
}: {
  view: RequestArticleContextData['view'];
  article: ArticleWithRelations;
}) => {
  const stepConfig = article.step?.step === 'quality-control' ? article.step.config : undefined;

  view.qualityControl.editable = true;
  view.qualityControl.photos.required = !!stepConfig?.fields?.photos?.required;
};
